<template>
  <div class="ledger-pagination">
    <span class="ledger-pagination__info">
      {{ rangeStart }}–{{ rangeEnd }} dari {{ totalData }}
    </span>
    <div class="ledger-pagination__controls">
      <label class="ledger-pagination__per-page">
        <span class="ledger-pagination__per-page-label">Baris</span>
        <select
          class="ledger-pagination__select"
          :value="localRow"
          @change="onRowChange($event.target.value)">
          <option v-for="opt in rowOptions" :key="opt" :value="opt">{{ opt }}</option>
        </select>
      </label>
      <div class="ledger-pagination__nav">
        <button
          type="button"
          class="ledger-pagination__btn"
          :disabled="currentPage <= 1"
          aria-label="Halaman sebelumnya"
          @click="goToPage(currentPage - 1)">
          <v-icon x-small>mdi-chevron-left</v-icon>
        </button>
        <span class="ledger-pagination__page">{{ currentPage }} / {{ totalPages }}</span>
        <button
          type="button"
          class="ledger-pagination__btn"
          :disabled="currentPage >= totalPages"
          aria-label="Halaman berikutnya"
          @click="goToPage(currentPage + 1)">
          <v-icon x-small>mdi-chevron-right</v-icon>
        </button>
        <button
          type="button"
          class="ledger-pagination__btn ledger-pagination__btn--refresh"
          aria-label="Muat ulang"
          @click="$emit('reload-page', { row: localRow, page: currentPage })">
          <v-icon x-small>mdi-refresh</v-icon>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProjectLedgerPagination',
  props: {
    model: {
      type: Object,
      default: () => ({})
    },
    display: {
      type: Object,
      default: () => ({ page: 1, row: 20 })
    }
  },
  data () {
    return {
      rowOptions: [10, 15, 20, 50, 100],
      localRow: 20,
      localPage: 1
    }
  },
  computed: {
    currentPage () {
      return Number(this.model.current) || this.localPage || 1
    },
    totalPages () {
      return Number(this.model.total_page) || 1
    },
    totalData () {
      return Number(this.model.total_data) || 0
    },
    localRowComputed () {
      return this.display.row || this.localRow
    },
    rangeStart () {
      if (this.totalData === 0) return 0
      return (this.currentPage - 1) * this.localRowComputed + 1
    },
    rangeEnd () {
      if (this.totalData === 0) return 0
      return Math.min(this.currentPage * this.localRowComputed, this.totalData)
    }
  },
  watch: {
    'display.row' (val) {
      if (val) this.localRow = val
    },
    'model.current' (val) {
      if (val) this.localPage = val
    }
  },
  created () {
    this.localRow = this.display.row || 20
    this.localPage = this.model.current || 1
  },
  methods: {
    goToPage (page) {
      const p = Math.max(1, Math.min(page, this.totalPages))
      this.localPage = p
      this.$emit('change-page', { row: this.localRow, page: p })
    },
    onRowChange (val) {
      this.localRow = Number(val)
      this.localPage = 1
      this.$emit('change-page', { row: this.localRow, page: 1 })
    }
  }
}
</script>

<style scoped>
.ledger-pagination {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
  padding: 10px 14px;
  background: #f7f8fa;
  border-top: 1px solid #e0e3e8;
  font-size: 12px;
  color: #374151;
}

.ledger-pagination__info {
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
  font-weight: 600;
  color: #1f2933;
}

.ledger-pagination__controls {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
}

.ledger-pagination__per-page {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin: 0;
}

.ledger-pagination__per-page-label {
  font-size: 11px;
  font-weight: 600;
  color: #374151;
}

.ledger-pagination__select {
  height: 28px;
  padding: 0 8px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  background: #fff;
  font-size: 12px;
  font-weight: 600;
  color: #374151;
  cursor: pointer;
  outline: none;
}
.ledger-pagination__select:focus {
  border-color: #0072B2;
  box-shadow: 0 0 0 2px rgba(0, 114, 178, 0.15);
}

.ledger-pagination__nav {
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

.ledger-pagination__page {
  min-width: 48px;
  text-align: center;
  font-weight: 700;
  font-variant-numeric: tabular-nums;
  color: #1f2933;
  font-size: 12px;
}

.ledger-pagination__btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  background: #fff;
  color: #374151;
  cursor: pointer;
  transition: background 0.12s ease, border-color 0.12s ease;
}
.ledger-pagination__btn:hover:not(:disabled) {
  background: #e8f2f8;
  border-color: #0072B2;
  color: #0072B2;
}
.ledger-pagination__btn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}
.ledger-pagination__btn--refresh {
  margin-left: 4px;
}

@media (max-width: 600px) {
  .ledger-pagination {
    flex-direction: column;
    align-items: stretch;
  }
  .ledger-pagination__controls {
    justify-content: space-between;
  }
}
</style>
